module.exports = __webpack_public_path__ + "static/media/purchased.53594cc5.svg";